import React from 'react';

import {
  BrancheDto,
  BrancheDtoBrancheEnum,
  DossierResponseDto,
  EntreeVehiculeViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import BaseForm from 'components/BaseForm/BaseForm';
import BaseSelectJuridiction from 'components/BaseForm/Select/juridiction/BaseSelectJuridiction';
import { FormInputProps } from 'components/BaseForm/types';
import { useEnvironnement } from 'hooks/EnvironementStoreContext';
import {
  isJusticeFieldRequiredByBranche,
  shouldDisplayJusticeFeatureBasedOnBranche,
} from 'utils/justice/methods';

import { EntreVehiculeFormValues } from './types';
import { generateEntreeVehiculeFromDossier } from './utils';

interface WithJusticeEntreeVehiculeFormProps {
  close: () => void;
  dossier: DossierResponseDto;
  inProgress: boolean;
  validateField: (
    field: EntreeVehiculeViolationDtoFormFieldEnum,
    formValues: EntreVehiculeFormValues,
  ) => Promise<void>;
  submit: (values: EntreVehiculeFormValues) => void;
  branche?: BrancheDto;
  baseInputs: FormInputProps<
    EntreVehiculeFormValues,
    EntreeVehiculeViolationDtoFormFieldEnum
  >[];
  autoriteFourriereSelectInput: FormInputProps<
    EntreVehiculeFormValues,
    EntreeVehiculeViolationDtoFormFieldEnum
  >;
}

const WithJusticeEntreeVehiculeForm = ({
  close,
  dossier,
  inProgress,
  validateField,
  submit,
  branche,
  baseInputs,
  autoriteFourriereSelectInput,
}: WithJusticeEntreeVehiculeFormProps) => {
  const shouldDisplayAutoriteFourriereSelect =
    branche?.branche !== BrancheDtoBrancheEnum.INERTE;
  const [{ JUSTICE_ACTIVE_BOOL }] = useEnvironnement();

  const shouldDisplayFicheJudiciaire =
    shouldDisplayJusticeFeatureBasedOnBranche(JUSTICE_ACTIVE_BOOL, branche);

  const inputJuridiction: FormInputProps<
    EntreVehiculeFormValues,
    EntreeVehiculeViolationDtoFormFieldEnum
  > = {
    field: EntreeVehiculeViolationDtoFormFieldEnum.ID_CORRELATION_JURIDICTION,
    required: isJusticeFieldRequiredByBranche(JUSTICE_ACTIVE_BOOL, branche),
    name: 'juridiction',
    label: 'Juridiction',
    render: () => <BaseSelectJuridiction />,
  };

  const inputs: FormInputProps<
    EntreVehiculeFormValues,
    EntreeVehiculeViolationDtoFormFieldEnum
  >[] = [
    ...(shouldDisplayAutoriteFourriereSelect
      ? [autoriteFourriereSelectInput]
      : []),
    ...baseInputs,
    ...(shouldDisplayFicheJudiciaire ? [inputJuridiction] : []),
  ];

  return (
    <BaseForm
      initialValues={generateEntreeVehiculeFromDossier(dossier)}
      isSubmitting={inProgress}
      validateField={validateField}
      onSubmit={submit}
      onCancel={close}
      inputs={inputs}
    />
  );
};

export default WithJusticeEntreeVehiculeForm;
